import axios from 'axios';

import callApi from '../service/callApi';

export const getAdminCompanyLogo = (initDataId, serverUrl) => {
  return callApi.request({
    url: `${serverUrl}/api/sonar-data/logo/${initDataId}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
};

export const getConsumerCompanyLogo = (initDataId, serverUrl, projectName, projectPassword) => {
  return axios.request({
    url: `${serverUrl}/api/consumer/sonar/logo?id=${initDataId}`,
    method: 'POST',
    responseType: 'arraybuffer',
    data: {
      projectName,
      projectPassword,
    },
  });
};
